import { useEffect, useState, useCallback } from 'react';

const SESSION_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes of inactivity
const WARNING_BEFORE_MS = 5 * 60 * 1000;   // Show warning 5 minutes before timeout

function SessionManager({ onLogout }) {
  const [showWarning, setShowWarning] = useState(false);
  const [countdown, setCountdown] = useState(0);

  const resetTimer = useCallback(() => {
    localStorage.setItem('last_activity', Date.now().toString());
    setShowWarning(false);
  }, []);

  const handleLogout = useCallback(() => {
    localStorage.removeItem('user');
    if (onLogout) onLogout();
    else window.location.href = '/login';
  }, [onLogout]);

  useEffect(() => {
    const events = ['mousedown', 'keydown', 'scroll', 'touchstart'];
    events.forEach(e => window.addEventListener(e, resetTimer, { passive: true }));

    const interval = setInterval(() => {
      const user = localStorage.getItem('user');
      if (!user) return;

      const lastActivity = parseInt(localStorage.getItem('last_activity') || Date.now().toString(), 10);
      const elapsed = Date.now() - lastActivity;
      const remaining = SESSION_TIMEOUT_MS - elapsed;

      if (remaining <= 0) {
        handleLogout();
      } else if (remaining <= WARNING_BEFORE_MS) {
        setShowWarning(true);
        setCountdown(Math.ceil(remaining / 1000));
      } else {
        setShowWarning(false);
      }
    }, 1000);

    return () => {
      events.forEach(e => window.removeEventListener(e, resetTimer));
      clearInterval(interval);
    };
  }, [resetTimer, handleLogout]);

  if (!showWarning) return null;

  const minutes = Math.floor(countdown / 60);
  const seconds = countdown % 60;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 10000,
      background: '#fef3c7', borderBottom: '2px solid #f59e0b',
      padding: '12px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
    }}>
      <span style={{ color: '#92400e', fontWeight: 500, fontSize: '0.9rem' }}>
        ⚠️ Session expires in {minutes}:{seconds.toString().padStart(2, '0')} due to inactivity
      </span>
      <div style={{ display: 'flex', gap: 8 }}>
        <button
          onClick={resetTimer}
          style={{ padding: '6px 16px', background: '#16a34a', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontWeight: 600, fontSize: '0.85rem' }}
        >
          Stay Logged In
        </button>
        <button
          onClick={handleLogout}
          style={{ padding: '6px 16px', background: '#dc2626', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontWeight: 600, fontSize: '0.85rem' }}
        >
          Log Out
        </button>
      </div>
    </div>
  );
}

export default SessionManager;
